<template>
  <article class="category flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Ко Дню Победы
    </h1>
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedVideoCard
        v-for="(item, index) in videos"
        :key="item.id || index"
        :data="item"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        @open:video="handleOpenVideo(item)"
      />
    </div>
  </article>
</template>

<script setup>
import { Fancybox } from 'fancyapps-ui';

import konchalovskyFound from '@/assets/data/konchalovsky-found';
import { getYoutubePreview } from '@/services/helpers';

useHead({
  title:
    'Видеолекции по истории РФ для школьников и студентов | Смотреть на Федеральном портале Истории России',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Видеолекции истории России от выдающихся профессоров и историков нашей страны. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
});

const videos = computed(() => {
  return konchalovskyFound.map((video) => {
    const preview = getYoutubePreview(video.video_code);
    return { ...video, image: { preview } };
  });
});

const handleOpenVideo = (item) => {
  new Fancybox([
    {
      src: item.video_code,
      caption: item.title,
      type: 'iframe',
      preload: false,
      Html: {
        autoSize: false,
      },
      customClass: 'my-iframe',
    },
  ]);
};
</script>
